// Debounced Turbo-driven search for the admin users list.
import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
    static targets = ["input"]
    static values = { delay: Number }

    connect() {
        this.timeout = null

        // Restore focus after Turbo stream list refreshes.
        requestAnimationFrame(() => {
            if (document.activeElement !== this.inputTarget) {
                this.inputTarget.focus()

                // Keep cursor at the end to continue typing naturally.
                const length = this.inputTarget.value.length
                this.inputTarget.setSelectionRange(length, length)
            }
        })
    }

    search() {
        clearTimeout(this.timeout)

        this.timeout = setTimeout(() => {
            const query = this.inputTarget.value
            const url = new URL(window.location.href)

            url.searchParams.set("q", query)
            url.searchParams.delete("page")

            Turbo.visit(url.toString(), { action: "replace" })
        }, this.delayValue || 300)
    }
}
